// extracted by mini-css-extract-plugin
export var dividerLine = "_9a-3";
export var itemImage = "_9a-9";
export var lightDivider = "_9a-4";
export var modalContent = "_9a-5";
export var modalContentCompact = "_9a-6";
export var productCard = "_9a-a";
export var productImage = "_9a-b";
export var productImageCompact = "_9a-7";
export var productImagePlaceholder = "_9a-c";
export var productImagePlaceholderCompact = "_9a-8";
export var progressBarBackground = "_9a-1";
export var progressBarContainer = "_9a-0";
export var progressBarFill = "_9a-2";